<template>
  <div class="dialog">
      <p>由于您发起退款，你购买的救援产品所产生的发票将会失效，请熟知 </p>
      <div class="dialogBox">
      	<p><b>发票信息如下</b></p>
      	<p>产品名称：{{prodectName}}</p>
      	<p>发票号码：{{dataObj.invoiceSid}}</p>
      	<p>发票金额：{{dataObj.amount/100}} 元</p>
      	<p>开票单位：江泰救援服务有限公司</p>
      </div>
  </div>
</template>

<script>
  import { invoiceDetail } from '@/axios/api'
  export default {
    data() {
      return {
        dataObj:{}
      }
    },
    props:[
      'fpdm',
      'fphm',
      'prodectName'
    ],
    mounted() {
      this.getData()
    },
    methods:{
      getData(){
        invoiceDetail({
          fpdm:this.fpdm,
          fphm:this.fphm
        })
        .then(res => {
          console.log(res);
          this.dataObj=res.data.obj
        })
        .catch(err => {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  .dialogBox{margin-top: 20px;}
  .dialogBox p{line-height: 30px;}
</style>



// WEBPACK FOOTER //
// src/components/refundDialog/index.vue